module.exports = __webpack_public_path__ + "static/media/news-4.29429434.jpg";